import { render, staticRenderFns } from "./qiquan.vue?vue&type=template&id=1bd95e9c&"
import script from "./qiquan.vue?vue&type=script&lang=js&"
export * from "./qiquan.vue?vue&type=script&lang=js&"
import style0 from "./qiquan.vue?vue&type=style&index=0&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports